import type { ReactNode } from 'react';

export const symbol_car_fan_mid_low_right: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M541-242 437-66q-6 11-18 14t-23-3q-11-6-14-18t3-23l127-217q8-14 22-22t30-8h111l62-223q9-32 34.5-52.5T829-639q44 0 72 34t19 77l-46 238q-4 21-20.5 34.5T815-242H541Zm308-598q29 0 50 21t21 50q0 29-21 50t-50 21q-29 0-50-21t-21-50q0-29 21-50t50-21ZM511-683H271q-13 0-21.5-8.5T241-713q0-13 8.5-21.5T271-743h239l-96-96q-9-9-9-21t9-21q9-9 21-9t21 9l148 148q5 5 7 10t2 11q0 6-2 11t-7 10L456-543q-9 9-21 9t-21-9q-9-9-9-21t9-21l97-98ZM199-331v-239q0-13 8.5-21.5T229-600q13 0 21.5 8.5T259-570v238l97-96q9-9 21-9t21 9q9 9 9 21.5t-9 21.5L250-237q-5 5-10 7t-11 2q-6 0-11-2t-10-7L61-385q-9-9-9-21t9-21q9-9 21-9t21 9l96 96Z"
		/>
	</svg>
);
